<template>
  <div>
    <Row style="margin-bottom: 10px;" :gutter="12">
      <Col span="12">
        <Card>
          <p slot="title" style="line-height: 16px;font-size:13px;color:#000;height: 15px;">{{$t('resourceLifecycle.resourceType')}}</p>
          <div id="pieResourceType" style="width:100%;height: 250px;"></div>
        </Card>
      </Col>
      <Col span="12">
        <Card>
          <p slot="title" style="line-height: 16px;font-size:13px;color:#000;height: 15px;">{{$t('resourceLifecycle.resourcespendmonthstatistics')}}</p>
          <div id="monthResource" style="width:100%;height: 250px;"></div>
        </Card>
      </Col>

    </Row>
    <Row style="margin-bottom: 10px;" :gutter="12">
      <Col span="24">
        <Card>
          <p slot="title" style="line-height: 16px;font-size:13px;color:#000;height: 15px;">{{$t( 'resourceLifecycle.listofresources' )}}</p>
          <Table :no-data-text="$t('common.noData')" class="table-css" height="250" :columns="columns" :data="resourceDate" size="small" :loading="resourceLoading"></Table>
        </Card>
      </Col>
    </Row>
    <Form :label-width="90">
      <Row style="margin-bottom: 10px;" :gutter="12">
        <Col span="24">
          <Card>
            <p slot="title" style="line-height: 16px;font-size:13px;color:#000;height: 15px;">{{$t( 'resourceLifecycle.resourcesspentthismonth' )}}</p>
            <Row style="margin-top: 10px;">
              <Col span="12">
                <FormItem :label="$t( 'resourceLifecycle.fees' )">
                  <i style="font-size: 20px;">￥ {{currentMonthlyResourceTotalCost}}</i>
                </FormItem>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
    </Form>
  </div>
</template>

<script>
  var operationReportVue = {};
  export default {
    name: 'OperationReport',
    data () {
      return {
        currentMonthlyResourceTotalCost:'',
        currentMonthlyResourceCostsForTypes:[],
        newCurrentMonthlyResourceCostsForTypesList:[],
        chartPieResourceType:'', // 资源类型
        chartMonthResource:'',
        awsPrice:[],
        azurePrice:[],
        resourceTypeList:[],//资源花费月统计图
        resourceLoading: false,
        columns: [{
          title: this.$t( 'resourceLifecycle.cloudPlatform' ),
          key: 'platform'
        },
          {
            title: this.$t( 'resourceLifecycle.resourceType' ),
            key: 'resourceType'
          },
          {
            title: this.$t( 'resourceLifecycle.numberofresources' ),
            key: 'resourceNumber'
          },
          {
            title: this.$t( 'resourceLifecycle.totalresourcecost$' ),
            key: 'currentMonthlyTotalCost'
          }],
        resourceDate:[],
      }
    },
    beforeCreate: function() {
      operationReportVue=this;
    },
    mounted:function(){
      // 自适应不同屏幕尺寸
      const self=this;
      window.addEventListener("resize",function(){
        self.chartPieResourceType.resize();
        self.chartMonthResource.resize();
      });
    },
    created(){
      this.$nextTick(function() {
        operationReportVue.bill();
      })
    },
    methods: {
      /******************所有图表*******************************************************/
      init:function(){
        this.$nextTick(function() {
          operationReportVue.pieResourceTypeLine();
          operationReportVue.monthResourceLine();
        });
      },
      /********************************************/
      // 所有接口
      bill:function(){
        this.resourceLoading=true;
        this.currentMonthlyResourceCostsForTypes=[];
        this.$api.bill.getBillStatistics({})
          .then(res => {
            // 当前月总花费
            this.currentMonthlyResourceTotalCost=res.data.currentMonthlyResourceTotalCost;
            // 资源类型
            if(res.data.currentMonthlyResourceCostsForTypes!=undefined){
              this.currentMonthlyResourceCostsForTypes=res.data.currentMonthlyResourceCostsForTypes;
              this.newCurrentMonthlyResourceCostsForTypesList=[];
              for(var i=0;i<this.currentMonthlyResourceCostsForTypes.length;i++){
                var CurrentMonthlyResourceCostsForTypesCopy = new Object();
                CurrentMonthlyResourceCostsForTypesCopy.name = this.currentMonthlyResourceCostsForTypes[i].name;
                this.newCurrentMonthlyResourceCostsForTypesList.push(CurrentMonthlyResourceCostsForTypesCopy);
              }
            }
            // 资源列表
            this.resourceDate = res.data.billStatisticsResponseDTOList;
            /*********资源花费月统计图**********/
            // x轴资源类型
            if(res.data.currentMonthlyResourceCostsForTypesOfPlatforms!=undefined){
              this.resourceTypeList = res.data.currentMonthlyResourceCostsForTypesOfPlatforms.resourceTypeList;
              // AWS
              this.awsPrice=res.data.currentMonthlyResourceCostsForTypesOfPlatforms.awsPrice;
              // Azure
              this.azurePrice=res.data.currentMonthlyResourceCostsForTypesOfPlatforms.azurePrice;
            }
            this.resourceLoading=false;
            operationReportVue.init();
          })
      },
      /******************图表*******************************************************/
      // 资源类型
      pieResourceTypeLine:function(){
        this.chartPieResourceType=this.$echarts.init(document.getElementById("pieResourceType"));
        this.chartPieResourceType.setOption({
          tooltip : {
            trigger: 'item'
          },
          legend: {
            type: 'scroll',
            orient: 'vertical',
            left: 'left',
            data: this.newCurrentMonthlyResourceCostsForTypesList
          },
          series : [
            {
              name: this.$t( 'resourceLifecycle.resourceType' ),
              type: 'pie',
              radius : '78%',
              center: ['50%', '50%'],
              data:this.currentMonthlyResourceCostsForTypes,
              labelLine:{
                normal:{
                  length:1
                }
              },
              itemStyle: {
                emphasis: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }
          ]
        })
      },
      // 资源花费月统计图
      monthResourceLine:function(){
        this.chartMonthResource=this.$echarts.init(document.getElementById("monthResource"));
        this.chartMonthResource.setOption({
          tooltip : {
            trigger: 'axis',
            axisPointer : {            // 坐标轴指示器，坐标轴触发有效
              type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
            }
          },
          legend: {
            data:['AWS','Azure']
          },
          xAxis: {
            type: 'category',
            data: this.resourceTypeList
          },
          yAxis: {
            type: 'value'
          },
          grid: {
            left: '3%',
            bottom: '3%',
            containLabel: true
          },
          series: [
            {
              name:'AWS',
              type:'bar',
              barGap:'0%',
              barMinHeight:1,
              barWidth:25,
              data:this.awsPrice
            },
            {
              name:'Azure',
              type:'bar',
              barGap:'0%',
              barMinHeight:1,
              barWidth:25,
              data:this.azurePrice
            }
          ]
        })
      },
    }
  }
</script>

<style scoped>
  .title
  {
    font-size:13px;
    font-weight: 600;
    padding: 10px;
    float:left;
    color:#000;
    margin-bottom: 0px;
  }
  /* 滚动条 */
  .table-css >>> .ivu-table-overflowY::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }
  .table-css >>> .ivu-table-overflowY::-webkit-scrollbar-thumb {
    border-radius: 5px;
    background: #ccc;
  }
  .table-css >>> .ivu-table-overflowY::-webkit-scrollbar-track {
    background: #eeeeef;
  }
  .table-css >>> .ivu-table-overflowY::-webkit-scrollbar-corner {
    background-color: #eeeeef;
  }
  .table-css >>> .ivu-table-overflowX{
    overflow-x: hidden !important;
  }
</style>




// WEBPACK FOOTER //
// src/components/resource_lifecycle_management/resource_service_operation_report/operation_report/OperationReport.vue